import React from 'react'

const SearchSvg = () => {
  return (
    <svg width='18px' height='18px' viewBox='0 0 18 18' version='1.1'>
      <title>search</title>
      <desc>Created with Sketch.</desc>
      <defs />
      <g
        id='icons'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          transform='translate(-59.000000, -234.000000)'
          id='search'
          fill='#ffffff '
        >
          <g transform='translate(59.000000, 234.000000)'>
            <path
              d='M12.5,11 L11.7,11 L11.4,10.7 C12.4,9.6 13,8.1 13,6.5 C13,2.9 10.1,0 6.5,0 C2.9,0 0,2.9 0,6.5 C0,10.1 2.9,13 6.5,13 C8.1,13 9.6,12.4 10.7,11.4 L11,11.7 L11,12.5 L16,17.5 L17.5,16 L12.5,11 L12.5,11 Z M6.5,11 C4,11 2,9 2,6.5 C2,4 4,2 6.5,2 C9,2 11,4 11,6.5 C11,9 9,11 6.5,11 L6.5,11 Z'
              id='Shape'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SearchSvg
